import type { IPlatformAdapter } from './ports/IPlatformAdapter'
import type { PlatformLaunchPayload } from './ports/types'

export const PLATFORM_ADAPTER = Symbol.for('Platform.IPlatformAdapter')
export const PLATFORM_PAYLOAD = Symbol.for('Platform.LaunchPayload')

export type PlatformAdapterToken = typeof PLATFORM_ADAPTER
export type PlatformPayloadToken = typeof PLATFORM_PAYLOAD

export type BoundPlatformAdapter = IPlatformAdapter
export type BoundPlatformPayload = PlatformLaunchPayload
